import React, { useEffect, useState } from "react";
import { Button } from "./Elements";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/fontawesome-free-solid";

import styled from "styled-components";

const QuestionWrapper = styled.li`
  position: relative;
  font-size: 18px;
  margin-bottom: 10px;
  width: 100%;
  background-color: #f0f6ff;
  border: 1px solid #d0d6dd;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 10px;
  flex-direction: column;
  transition: background-color 1s ease;

  &.answered {
    background-color: #d1fae5;
    border: 1px solid #a7f3d0;
  }
`;

const SelectorItem = styled.div`
  padding: 5px 10px;
  cursor: pointer;
  color: var(--main-font-color);
  &:hover {
    background-color: var(--sidebar-active-item-bg);
    color: var(--sidebar-active-item-color);
  }

  &.selected {
    font-weight: bold;
    text-decoration: underline;
    background-color: var(--sidebar-active-item-bg);
    color: var(--sidebar-active-item-color);
  }
`;

export const Approved = ({
  display,
  questions = [],
  socketRef,
  liveEvent,
  setQuestions,
  height,
}) => {
  const event_id = liveEvent?.public_id ?? liveEvent?.id;
  const { token } = useSelector((state) => state.users);
  const [viewType, setViewType] = useState("list");
  const [groupedQuestions, setGroupedQuestions] = useState({});
  const [groupExpanded, setGroupExpanded] = useState({});

  useEffect(() => {
    if (viewType === "grouped") {
      const grouped = questions.reduce((acc, question) => {
        const groupId = question.group_id || "ungrouped";
        if (!acc[groupId]) {
          acc[groupId] = [];
          groupExpanded[groupId] = false;
        }
        acc[groupId].push(question);
        return acc;
      }, {});
      setGroupedQuestions(grouped);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewType, questions]);

  return (
    <div
      style={{
        display: display ? "block" : "none",
        paddingLeft: "20px",
        height: height,
        maxHeight: "95vh",
        overflow: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
          marginBottom: "10px",
          width: "100%",
        }}
      >
        <SelectorItem
          className={viewType === "list" ? "selected" : ""}
          onClick={() => setViewType("list")}
        >
          List
        </SelectorItem>
        {" | "}
        <SelectorItem
          className={viewType === "grouped" ? "selected" : ""}
          onClick={() => setViewType("grouped")}
        >
          Grouped
        </SelectorItem>
      </div>
      <ul>
        {viewType === "grouped" ? (
          <>
            {Object.keys(groupedQuestions).length > 0 ? (
              Object.keys(groupedQuestions).map((groupId) => {
                const groupQuestions = groupedQuestions[groupId];
                const question = groupQuestions[0];

                return (
                  <QuestionWrapper
                    key={groupId}
                    className={
                      question.status === "answered" || question.response
                        ? "answered"
                        : ""
                    }
                  >
                    {groupQuestions.length > 1 ? (
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "15px",
                        }}
                      >
                        {groupExpanded[groupId] ? (
                          <FontAwesomeIcon
                            size="lg"
                            icon={faCaretUp}
                            onClick={() =>
                              setGroupExpanded((prev) => ({
                                ...prev,
                                [groupId]: false,
                              }))
                            }
                          />
                        ) : (
                          <FontAwesomeIcon
                            size="lg"
                            icon={faCaretDown}
                            onClick={() =>
                              setGroupExpanded((prev) => ({
                                ...prev,
                                [groupId]: true,
                              }))
                            }
                          />
                        )}
                      </div>
                    ) : null}
                    <div>
                      {groupQuestions.length} Question
                      {groupQuestions.length > 1 ? "s" : ""}
                    </div>
                    <div>{question?.message}</div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#808080",
                        fontStyle: "italic",
                        fontWeight: "bold",
                      }}
                    >
                      {question?.status}
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#808080",
                        fontStyle: "italic",
                      }}
                    >
                      From: {question?.user?.nickname}
                    </div>
                    {groupQuestions.length > 1 && groupExpanded[groupId]
                      ? groupQuestions.slice(1).map((q, idx) => (
                        <div
                          key={idx}
                          style={{
                            marginTop: "10px",
                            paddingTop: "10px",
                            borderTop: "1px solid #d0d6dd",
                          }}
                        >
                          <div>{q?.message}</div>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "#808080",
                              fontStyle: "italic",
                            }}
                          >
                            From: {q?.user?.nickname}
                          </div>
                        </div>
                      ))
                      : null}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "5px",
                        fontSize: "14px",
                        justifyContent: "space-around",
                        width: "100%",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        bgcolor="#89abf5"
                        textcolor="#f0f6ff"
                        disabled={
                          question.status === "answered" || question.response
                        }
                        onClick={() => {
                          if (socketRef.current) {
                            socketRef.current.emit("update-message-status", {
                              event_id: event_id,
                              broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                              message_id: question.public_id,
                              status: "answered",
                              token: token,
                            });
                          }

                          setQuestions((prevQuestions) =>
                            prevQuestions.map((q) =>
                              q.public_id === question.public_id
                                ? { ...q, status: "answered" }
                                : q
                            )
                          );
                        }}
                      >
                        <i className="fas fa-check "></i>
                        Mark as Answered
                      </Button>
                      <Button
                        disabled={
                          question.status === "answered" ||
                          question.response !== null
                        }
                        bgcolor="#f3f4f6"
                        textcolor="#334155"
                        onClick={() => {
                          console.log("!!! DISMISSING QUESTION: ", question);
                          socketRef.current.emit("update-message-status", {
                            event_id: event_id,
                            broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                            message_id: question.public_id,
                            status: "pending",
                            token: token,
                          });

                          /*setQuestions((prevQuestions) =>
                      prevQuestions.filter((q) => q.id !== question.id)
                    );*/
                        }}
                      >
                        <i className="fas fa-times"></i>
                        Unapprove
                      </Button>
                    </div>
                  </QuestionWrapper>
                );
              })
            ) : (
              <li style={{ fontSize: "18px", paddingLeft: "20px" }}>
                No questions available.
              </li>
            )}
          </>
        ) : (
          <>
            {questions.length > 0 ? (
              questions.map((question, index) => (
                <QuestionWrapper
                  key={index}
                  className={
                    question.status === "answered" || question.response
                      ? "answered"
                      : ""
                  }
                >
                  <div>{question?.message}</div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                      fontWeight: "bold",
                    }}
                  >
                    {question?.status}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "#808080",
                      fontStyle: "italic",
                    }}
                  >
                    From: {question?.user?.nickname}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "5px",
                      fontSize: "14px",
                      justifyContent: "space-around",
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      bgcolor="#89abf5"
                      textcolor="#f0f6ff"
                      disabled={
                        question.status === "answered" || question.response
                      }
                      onClick={() => {
                        if (socketRef.current) {
                          socketRef.current.emit("update-message-status", {
                            event_id: event_id,
                            broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                            message_id: question.public_id,
                            status: "answered",
                            token: token,
                          });
                        }

                        setQuestions((prevQuestions) =>
                          prevQuestions.map((q) =>
                            q.public_id === question.public_id
                              ? { ...q, status: "answered" }
                              : q
                          )
                        );
                      }}
                    >
                      <i className="fas fa-check "></i>
                      Mark as Answered
                    </Button>
                    <Button
                      disabled={
                        question.status === "answered" ||
                        question.response !== null
                      }
                      bgcolor="#f3f4f6"
                      textcolor="#334155"
                      onClick={() => {
                        console.log("!!! DISMISSING QUESTION: ", question);
                        socketRef.current.emit("update-message-status", {
                          event_id: event_id,
                          broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                          message_id: question.public_id,
                          status: "pending",
                          token: token,
                        });

                        /*setQuestions((prevQuestions) =>
                      prevQuestions.filter((q) => q.id !== question.id)
                    );*/
                      }}
                    >
                      <i className="fas fa-times"></i>
                      Unapprove
                    </Button>
                  </div>
                </QuestionWrapper>
              ))
            ) : (
              <li style={{ fontSize: "18px", paddingLeft: "20px" }}>
                No questions available.
              </li>
            )}
          </>
        )}
      </ul>
    </div>
  );
};

export default Approved;
